import React from 'react';
import { SignInPage } from '@backstage/core-components';
import { useTheme } from '@material-ui/core/styles';
import LogoFull from './LogoFull';
import Footer from './Footer';

// Render a custom header bar for the sign-in page:
// - Left: grey box matching sidebar with logo
// - Right: bar in the sidebar color with title taken from app.title
// Then render the SignInPage below with spacing so it does not overlap.
const SignInWithLogo = (props: any) => {
  const theme = useTheme();
  const titleStyle: React.CSSProperties = {
    background: theme.palette.navigation.background,
    fontSize: 20,
    fontWeight: 600,
    alignItems: "center",
    paddingTop: 10,
    paddingLeft: 10
  };

  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        height: '100vh',
        boxSizing: 'border-box',
      }}
    >
      {/* Hide the Backstage Header rendered inside SignInPage */}
      <style>{`header[class*="BackstageHeader"] { display: none !important; }`}</style>

      {/* Top Bar */}
      <div style={titleStyle}>
        <LogoFull />
      </div>

      {/* Main content + Footer wrapper */}
      <div
        style={{
          flex: 1,
          display: 'flex',
          flexDirection: 'column',
          overflow: 'hidden',
        }}
      >
        <div style={{ flex: 1, overflowY: 'auto' }}>
          <SignInPage {...props} />
        </div>
        <Footer />
      </div>
    </div>
  );
};

export default SignInWithLogo;
